export const useScoreTreshold = (score: number, over_5: boolean = false) => {
    if (over_5) {
        if (score >= 3.75) {
            return {
                treshold: 1,
                default: '#79DD7D',
                light: '#DFFEE0',
                dark: '#3D8A40',
            }
        }
        if (score >= 2.5 && score < 3.75) {
            return {
                treshold: 2,
                default: '#FFE981',
                light: '#FBFFE0',
                dark: '#BFAB4E',
            }
        }
        if (score >= 1.25 && score < 2.5) {
            return {
                treshold: 3,
                default: '#E89903',
                light: '#FCF3E2',
                dark: '#634100',
            }
        }
        if (score >= 0 && score < 1.25) {
            return {
                treshold: 4,
                default: '#FF6464',
                light: '#FDE1E1',
                dark: '#8D4E4E',
            }
        }
        /* if (score < 1) {
            return {
                treshold: 5,
                default: '#D9D9D9',
                light: '#929292',
                dark: '#929292',
            }
        } */
    }
    else {
        if (score >= 75) {
            return {
                treshold: 1,
                default: '#79DD7D',
                light: '#DFFEE0',
                dark: '#3D8A40',
            }
        }
        if (score >= 50 && score < 75) {
            return {
                treshold: 2,
                default: '#FFE981',
                light: '#FBFFE0',
                dark: '#BFAB4E',
            }
        }
        if (score >= 25 && score < 50) {
            return {
                treshold: 3,
                default: '#E89903',
                light: '#FCF3E2',
                dark: '#634100',
            }
        }
        if (score >= 0 && score < 25) {
            return {
                treshold: 4,
                default: '#FF6464',
                light: '#FDE1E1',
                dark: '#8D4E4E',
            }
        }
        /* if (score < 20) {
            return {
                treshold: 5,
                default: '#D9D9D9',
                light: '#929292',
                dark: '#929292',
            }
        } */
    }
}
